import _ from 'lodash';
import React, { Component, createRef } from 'react'
import { withRouter } from 'react-router';
import { Container, Grid, Dimmer, Loader ,Progress } from 'semantic-ui-react'
import {getSellerCustomerRequestForSeller, getSellerCustomerRequestForBuyer , 
    submitSellerCustomerRequestFormForSeller , submitSellerCustomerRequestFormForBuyer} from '../../../services/Seller';
import {
    capitalize as _capitalize,
    orderBy as _orderBy,
    isEmpty
} from 'lodash';
import ServiceNameHeader from '../../../components/ServiceNameHeader/ServiceNameHeader'
import previous_back_arrow from '../../../assets/images/newui/previous-button-arrow.svg';
import './CustomerRequestFormContainer.less';
import '../../../assets/css/chkbox-style.css'
import DGTextbox from '../../../components/FormControls/TextboxStepByStep/DGTextboxStepByStep';
import '../../../components/FormControls/Checkbox/DGCheckbox.less'
import DGRadioGroup from '../../../components/FormControls/RadioGroupStepByStep/DGRadioGroupStepByStep'
import DGTextarea from '../../../components/FormControls/TextareaStepByStep/DGTextareaStepByStep';
import DGMultiCheckBoxGroup from '../../../components/FormControls/MultiCheckBoxGroupStepByStep/DGMultiCheckBoxGroupStepByStep';
import { getSCService , 
    getServiceRequestFormByName as _getServiceRequestFormByName, 
    getServiceByName as _getServiceByName } from '../../../services/Services';
import { Transition } from 'react-transition-group';
import Formsy from 'formsy-react';
import fileResizer from '../../../helpers/fileResizer';
import { logSubmitFormValidated, logSubmitFormClicked } from '../../../common/analytics';
import GeneralMessage from '../../../components/GeneralMessage/GeneralMessage';
import RequestFormPageHeaderStepbyStep from 'components/FullPageHeaderStepbyStep/RequestFormPageHeaderStepbyStep';
import DGAddressAutoFill from 'components/FormControls/AddressAutofill/DGAddressAutoFill';
import SellerNotesModal from '../../../components/SellerCustomer/SellerNotesModal/SellerNotesModal';
import { format } from 'react-phone-input-auto-format'
import { NavigationUrls } from '../../../constants/NavigationUrls'

const initialState = {
    zip: '',
    serviceId: 0,
    categoryName: '',
    serviceName: '',
    requestData: {},
    loadPage: false,
    files: [],
    promoCode: '',
    showZipModal: false,
    showZipLoading: false,
    showSignInSignUpModal: false,
    showSignIn: false,
    showServiceSubmissionErrorMessage: false,
    serviceSubmissionErrorMessage: '',
    windowWidth: 0,
    windowHeight: 0,
    loadPage: false,
    showLoading: false,
    backgrounds: {},
    providers: [],
    pageHeading: '',
    sectionCounter : 0,
    totalSections : 0,
    hiddenSections : 0,
    showFormSection:true,
    promoCollapsState : false,
    promoIsInValid : false,
    promoApplied : false,
    promoValidationMessage : "",
    animationState : {},
    timeSlot: undefined,
    showPriceConfirmationModal: false,
    priceConfirmationDetails: {},
    newlyCreatedSbrID: 0,
    sbrFormData: {},


    requestData: undefined,
    sellerNotesModalOpen: false,
    sellerNotes:"",
    showError: false,
    customerDetails: undefined
};


const annimationDuration = "500";
const defaultStyle = {
    transition: `opacity 500ms ease-in-out`,
    opacity: 0,
  }

    const transitionStyles = {
        entering: { opacity: 1 },
        entered:  { opacity: 1 },
        exiting:  { opacity: 0 },
        exited:  { opacity: 0 },
      };

export class CustomerRequestFormContainer extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        this.formRef = createRef();
        this.serviceErrorRef = createRef();

        for (let i = 0; i < 50; i++) {
            this['section_' + i] = createRef();
        }

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.uploadCollapsibleButtonRef = createRef();
        this.promoCollapsibleButtonRef = createRef();
        this.uploadCollapsibleContainerRef = createRef();
        this.promoCollapsibleContainerRef = createRef();
        this.promoContainerShown = false;
        this.uploadContainerShown = false;
    }
    
    
    updateWindowDimensions() {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    async componentDidMount() {
        try {
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);
        }
        catch(e) {
            console.log(e)
        }

        let token = this.props.match.params.token;
        let sellerSEOName = this.props.match.params.sellerSEOName;

        let requestData = undefined;

        // if(token && sellerSEOName)
        // {
        //     let res = await getSellerCustomerRequestForBuyer(sellerSEOName,token)
        //         if(res.resStatus == 200)
        //         {
        //             requestData = res.data[0];
        //         }   
        
        // }else if(token)
        // {
            let res = await getSellerCustomerRequestForSeller(token)
                if(res.resStatus == 200)
                {
                    requestData = res.data[0];
                }
        // }
        
        if (requestData) {
            
            let serviceData = undefined;
            let serviceRes = await getSCService(requestData.scServiceID);

            if(serviceRes.resStatus == 200)
            {
                serviceData = serviceRes.data;
            }

          if (!requestData.serviceFormData || !serviceData) {
            this.props.history.push(`/`);
          } else {
            let totalHiddenSections = requestData.serviceFormData.formPages[0].sections.filter(
                (section) => {
                  return section.isHidden;
                }
              );

            requestData.serviceFormData.formPages[0].sections = [
              ...requestData.serviceFormData.formPages[0].sections.filter(
                (section) => {
                  return !section.isHidden;
                }
              ),
            ];

            this.setState({
              requestData: { ...requestData, formData : requestData.serviceFormData, serviceID : requestData.scServiceID},
              totalSections: requestData.serviceFormData.formPages[0].sections.length,
              hiddenSections: totalHiddenSections,
              sellerNotes: requestData.sellerNotes,
              service: serviceData,
              loadPage: true,
              pageHeading: "Service Request Form",
              customerDetails: {
                    customerName : requestData?.customer?.firstName + " " + requestData?.customer?.lastName , 
                    cellPhone : requestData?.customer?.cellPhone
                }
            });
          }
        } else {
            this.setState({showError: true})
        }
    
        if (window.innerWidth < 768)
        {
             window.addEventListener('scroll', this.onScroll);
        }        
    }

    onScroll = (event=null,keyboardToggle = false) => {

        const existingFixedHeader = document.getElementsByClassName('button-section-container-fixed');
        if (existingFixedHeader.length) {
            existingFixedHeader[0].classList.remove('button-section-container-fixed');
        }
        const existingFixedBoderCss = document.getElementsByClassName('form-container-remove-border');
        if (existingFixedBoderCss.length) {
            existingFixedBoderCss[0].classList.remove('form-container-remove-border');
        }

        var eligibleElems = document.getElementsByClassName('bottom-div-one');     
        if (eligibleElems.length) {
            const eligibleElem = eligibleElems[0];          
            if(!this.isInViewport(eligibleElem , 17) && eligibleElem.getBoundingClientRect().top >= 0)
            {
                document.getElementsByClassName('button-section-container')[0].classList.add("button-section-container-fixed");
                // document.getElementsByClassName('form-container')[0].classList.add("form-container-remove-border");
                if((!this.isInViewport(eligibleElem , -62) || !this.isInViewport(eligibleElem , 0) )&& eligibleElem.getBoundingClientRect().top >= 0)
                {
                    //document.getElementsByClassName('button-section-container')[0].classList.add("button-section-container-fixed");
                    document.getElementsByClassName('form-container')[0].classList.add("form-container-remove-border");
                }  
                
                if(!document.getElementsByClassName('picture-upload-section-fields').length)
                {
                    const sectionFields = document.getElementsByClassName('section-fields')[0];
                    const formContainer = document.getElementsByClassName('form-container')[0];
                    const buttonSectionContainer = document.getElementsByClassName('button-section-container-fixed')[0];
                    const sectionheaderHeight = document.getElementsByClassName('section-header')[0].getBoundingClientRect().height;  
                    let maxHeight =  ( buttonSectionContainer.getBoundingClientRect().top - formContainer.getBoundingClientRect().top - sectionheaderHeight - 35 );
                    let minHeight =  ( buttonSectionContainer.getBoundingClientRect().top - formContainer.getBoundingClientRect().top - sectionheaderHeight - 35 );   
                    if(maxHeight > 316)
                    {
                        maxHeight = 316;
                    } 
                    if(minHeight > 316)
                    {
                        minHeight = 316;
                    } 
                    if(maxHeight < 60)
                    {
                        maxHeight = 60;
                    }
                    if(minHeight < 60)
                    {
                        minHeight = 60;
                    }
                    if(sectionFields)
                    {
                        sectionFields.style.minHeight  = minHeight + "px";
                        sectionFields.style.maxHeight  = maxHeight + "px";
                    }
                }   
            }          
            
            if(document.getElementsByClassName('button-section-container-fixed').length == 0)
            {
                const sectionFields = document.getElementsByClassName('section-fields')[0];
                if(sectionFields)
                {
                    sectionFields.style.minHeight  = "316px";
                    sectionFields.style.maxHeight  = "316px"; 
                }                   
            }
            
            const sectionFields = document.getElementsByClassName('section-fields picture-upload-section-fields');
            if(sectionFields.length)
            {
                sectionFields[0].style.minHeight  = "unset";
                sectionFields[0].style.maxHeight  = "unset"; 
            }
        }
    }

    isInViewport(el , bottom) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.bottom-bottom <= (window.innerHeight || document.documentElement.clientHeight)    
        );
    }

    componentWillUnmount = () => {
        if (window.innerWidth < 768)
            window.removeEventListener('scroll', this.onScroll);
    }

    get formPages() {
        const { formData } = this.state.requestData || {};

        if (!formData) {
            return [];
        }
        return _orderBy(formData.formPages, 'pageOrder');
    }

    getSortedSection = (page = {}) => {
        const { sections } = page;
        if (!sections) {
            return [];
        }
        return _orderBy(sections, 'sectionOder');
    };

    getSortedFields = (section = {}) => {
        const { fields } = section;
        if (!fields) {
            return [];
        }
        return _orderBy(fields, 'fieldOrder');
    };


    renderPage = (page, pageIndex) => {

        const sections = this.getSortedSection(page);
        if(
            this.isLastSection()
            /*this.isPromoSection()*/ 
            )
        {
            const existingFixedHeader = document.getElementsByClassName('button-section-container-fixed');
            if (existingFixedHeader.length) {
                existingFixedHeader[0].classList.remove('button-section-container-fixed');
            }
            const existingFixedBoderCss = document.getElementsByClassName('form-container-remove-border');
            if (existingFixedBoderCss.length) {
                existingFixedBoderCss[0].classList.remove('form-container-remove-border');
            }
            if (window.innerWidth < 768)
            {
                window.removeEventListener('scroll', this.onScroll);
            }               
        }else
        {
            if (window.innerWidth < 768)
            {
                window.addEventListener('scroll', this.onScroll);
                this.onScroll();
            } 
        }

        return (<React.Fragment key={`sfd_page_${pageIndex} `}>
            {   
                //sections.map(this.renderSections)
                ( this.state.sectionCounter < sections.length  
                    // && !isHiddenSection  
                    ) ?
                this.renderSections(sections[this.state.sectionCounter] ,this.state.sectionCounter ) : null
            }
        </React.Fragment >)

    };

    renderSections = (section, sectionIndex) => {
        const { sectionValidationInfo, windowWidth, windowHeight } = this.state;
        let isFirstSection = false;
        let isLastSection = false;

        const sectionInfo = _.find(sectionValidationInfo, function (o) { return o.sectionIndex === sectionIndex });

        if (sectionInfo) {
            isFirstSection = (sectionInfo.sectionIndex === 0);
        }

        const fields = this.getSortedFields(section);

        let required = false;
        if (section.type === 'radio' || section.type === 'multi') {
            required = _.some(fields, { 'required': true });
        }

        switch (section.type) {
            case 'radio':
                return (
                    <React.Fragment key={sectionIndex}>
                        <div className="form-section-container">
                            <h3 className="section-header" ref={this['section_' + section.sectionID]}>
                                {section.headerText}
                            </h3>
                            <div className="section-fields" id={"field_"+fields[0].fieldID}>
                                <DGRadioGroup key={`radio_${section.sectionID}`}
                                    {...{
                                        required: required

                                    }}
                                    validationErrors={{
                                        isDefaultRequiredValue: 'Please select one of these',
                                    }}
                                    name={`${section.sectionID}`}
                                    fields={fields}
                                    sectionID={section.sectionID}
                                    onSelection={this.onRadioSelection}
                                >
                                </DGRadioGroup>
                            </div >
                        </div>
                    </React.Fragment >
                );
            case 'none':
                let fieldWidthOnLargeDevices = 0;
                if (fields.length === 1) {
                    fieldWidthOnLargeDevices = 16;
                }
                else {
                    fieldWidthOnLargeDevices = 16;
                }
                return (
                    <React.Fragment key={sectionIndex}>
                        <div className="form-section-container">
                            <h3 className="section-header">
                                {section.headerText}
                            </h3>
                            <div className="section-fields">
                                <Grid>
                                    {fields.map((field, fieldIndex) => {
                                        return (
                                            field.isHidden ? "" :
                                        <>
                                            <Grid.Column key={fieldIndex} id={"field_"+field.fieldID}
                                            computer={fieldWidthOnLargeDevices} mobile={16} tablet={fieldWidthOnLargeDevices}>
                                                {field.dataType == 'string' && <DGTextbox
                                                    sectionID={section.sectionID}
                                                    fieldID={field.fieldID}
                                                    innerRef={(c) => {
                                                        return c;
                                                    }}
                                                    onblur={(e) => this.onScroll(e,true)}   
                                                    onfocus={() => 
                                                        {
                                                            this.onScroll();                                                    
                                                            if (window.innerWidth < 768 
                                                                //&&  !this.isInViewport(document.getElementById("field_"+field.fieldID) , 0)
                                                                )
                                                            {
                                                                setTimeout(() => {
                                                                    document.getElementById("field_"+field.fieldID).scrollIntoView({
                                                                        behavior: 'smooth',
                                                                        //block: 'nearest', 
                                                                        inline: 'center'
                                                                    });                                                             
                                                                }, 50);  
                                                            }   
                                                        }
                                                    }
                                                    value={`${field.value}`}
                                                    name={`${section.sectionID}_${field.fieldID} `}
                                                    label={`${field.name} `}
                                                    {...{

                                                        required: field.required,
                                                        maxLength: field.maxLength,
                                                        placeholder: (field.placeholder ? field.placeholder : ''),

                                                    }}

                                                    validationErrors={{
                                                        isDefaultRequiredValue: `${field.name} is required`

                                                    }}

                                                ></DGTextbox>}
                                                {field.dataType == 'addressAutofill' && <DGAddressAutoFill
                                                    scrollableParentSelector ='.section-fields'
                                                    sectionID={section.sectionID}
                                                    fieldID={field.fieldID}
                                                    innerRef={(c) => {
                                                        return c;
                                                    }}
                                                    onblur={(e) => this.onScroll(e,true)}   
                                                    onfocus={() => 
                                                        {
                                                            this.onScroll();                                                    
                                                            if (window.innerWidth < 768 
                                                                //&&  !this.isInViewport(document.getElementById("field_"+field.fieldID) , 0)
                                                                )
                                                            {
                                                                setTimeout(() => {
                                                                    document.getElementById("field_"+field.fieldID).scrollIntoView({
                                                                        behavior: 'smooth',
                                                                        //block: 'nearest', 
                                                                        inline: 'center'
                                                                    });                                                             
                                                                }, 50);  
                                                            }   
                                                        }
                                                    }
                                                    value={`${field.value}`}
                                                    name={`${section.sectionID}_${field.fieldID} `}
                                                    label={`${field.name} `}
                                                    {...{

                                                        required: field.required,
                                                        maxLength: field.maxLength,
                                                        placeholder: (field.placeholder ? field.placeholder : ''),

                                                    }}

                                                    validationErrors={{
                                                        isDefaultRequiredValue: `${field.name} is required`

                                                    }}

                                                />}
                                            </Grid.Column>
                                        </>
                                        )
                                    })}
                                </Grid>

                            </div>
                        </div>
                    
                    </React.Fragment>
                )
            case 'notes':
                return (
                    <React.Fragment key={sectionIndex}>
                        <div className="form-section-container">
                            <h3 className="section-header">
                                {section.headerText}
                            </h3>
                            <div className="section-fields">
                                <Grid>
                                    {fields.map((field, fieldIndex) => {
                                        return (
                                            field.isHidden ? "" :
                                            <Grid.Column key={fieldIndex} computer={16} mobile={16} id={"field_"+field.fieldID}>
                                                <DGTextarea
                                                    sectionID={section.sectionID}
                                                    fieldID={field.fieldID}
                                                    name={`${field.name} `}
                                                    label={`${field.name} `}
                                                    value={`${field.value}`}
                                                    onblur={() => this.onScroll(true)}
                                                    onfocus={() => 
                                                        {
                                                            this.onScroll();  
                                                            if (window.innerWidth < 768)
                                                            {
                                                                setTimeout(() => {
                                                                    document.getElementById("field_"+field.fieldID).scrollIntoView({
                                                                        behavior: 'smooth',
                                                                        //block: 'nearest', 
                                                                        inline: 'center'
                                                                    });
                                                                }, 50);
                                                            }                                                                                                                     
                                                        }
                                                    }
                                                    {...{

                                                        required: field.required,
                                                        maxLength: field.maxLength,
                                                        placeholder: (field.placeholder ? field.placeholder : ''),

                                                    }}
                                                    validationErrors={{
                                                        isDefaultRequiredValue: `${field.name} is required`

                                                    }}
                                                ></DGTextarea>
                                            </Grid.Column>
                                        )
                                    })}
                                </Grid>
                            </div>
                        </div>
                    </React.Fragment>
                )
            case 'multi':
                return (
                    <React.Fragment key={sectionIndex}>
                        <div className="form-section-container" ref={this['section_' + section.sectionID]}>
                            <h3 className="section-header">
                                {section.headerText}
                            </h3>
                            <div className="section-fields" id={"field_"+fields[0].fieldID}>
                                <DGMultiCheckBoxGroup key={`radio_${section.sectionId}`}
                                    {...{
                                        required: required

                                    }}

                                    validationErrors={{
                                        isDefaultRequiredValue: 'Please select one of these',
                                    }}
                                    name={`${section.sectionID}`}
                                    sectionID={section.sectionID}
                                    fields={fields}
                                >
                                </DGMultiCheckBoxGroup>
                            </div >
                        </div>

                    </React.Fragment >
                );
        }
    };

    onRadioSelection = () => {
        this.onValidSubmit();
    }

    onInvalidSubmit = () => {      
        let { service } = this.state;
        logSubmitFormClicked(service, this.props.currentUser, 0);
        if (this.formRef && this.formRef.current) {
            const { inputs } = this.formRef.current;
            for (let i = 0; i < inputs.length; i++) {
                const input = inputs[i];

                if (!input.isValid()) {

                    if(input.props.fields)
                    {
                        document.getElementById("field_"+input.props.fields[0].fieldID).scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest', inline: 'start'
                        });
                    }else
                    {
                        document.getElementById("field_"+input.props.fieldID).scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest', inline: 'start'
                        });
                    }
                
                    break;
                }
            }
        }
    }

    onValidSubmit = () => {
        this.setState({showFormSection : false , animationState : transitionStyles.nextOut})

        setTimeout(() => {
            let { requestData, service, files } = this.state;
            logSubmitFormValidated(service, this.props.currentUser, 0);
            let { formData } = requestData;
            let page = formData.formPages[0];

            try {
                if (this.formRef && this.formRef.current) {
                    const { inputs } = this.formRef.current;

                    const sections = page.sections;

                    for (let i = 0; i < inputs.length; i++) {
                        const input = inputs[i];
                        const inputValue = input.getValue();
                        const sectionID = input.props.sectionID;
                        let section = _.find(page.sections, (sec) => {
                            return (sec.sectionID === sectionID);
                        }, 0);

                        const fieldID = input.props.fieldID;
                        if (fieldID) {

                            let field = _.find(section.fields, (fld) => {
                                return (fld.fieldID === fieldID);
                            }, 0);

                            field.value = inputValue ? inputValue : '';
                        }
                        else {
                            
                            _.forEach(section.fields, (field) => {
                                
                                if (!_.isEmpty(inputValue)) {
                                    
                                    if (_.includes(inputValue, field.fieldID.toString())) {
                                        
                                        field.value = 'checked';
                                    }else if(section.type == "radio" && field.value == 'checked')
                                    {
                                        field.value = '';
                                    }
                                }
                                else if (field.fieldID == inputValue) {
                                    
                                    field.value = 'checked';
                                }else if (field.value == "checked" && section.type === 'multi')
                                {
                                    
                                    field.value = 'checked';
                                }
                                else {
                                    
                                    if (section.type === 'multi') {
                                        field.value = '';
                                    }
                                    else {
                                        field.value = false;
                                    }
                                }
                            })
                        }
                    }
                }

                if(this.state.sectionCounter+1 < this.state.totalSections)
                {
                    this.setState({ sectionCounter: this.state.sectionCounter+1  , showFormSection : true
                        // , animationState : transitionStyles.nextIn
                        });
                        window.scrollTo({
                            top: 80,
                            behavior: 'smooth'
                        });
                    return;
                }    
            }
            catch (error) {
                this.setState({ showLoading: false, showServiceSubmissionErrorMessage: true, serviceSubmissionErrorMessage: error, convertingImages: false  , showFormSection : true}, () => {               
                    if (this.serviceErrorRef) {
                        this.serviceErrorRef.current.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                        });
                    }
                });
            }

            this.setState({ showLoading: true });
                   
            requestData.photos = [];

            this.setState({ requestData: requestData }, () => {

                this.compressImagesAndSubmitForm();
                // this.setState({sellerNotesModalOpen: true})
            });

        }, annimationDuration);
    }

    compressImagesAndSubmitForm = () => {
        const { requestData } = this.state;
        let convertedImages = [];
        if (requestData.photos && requestData.photos.length > 0) {
            this.setState({ convertingImages: true, showServiceSubmissionErrorMessage: false });
            requestData.photos.map(async (photo) => {
                try {

                    const compressedImage = await fileResizer.resizeImageBeforeUpload(photo);
                    convertedImages.push(compressedImage);
                }
                catch (error) {
                    this.setState({ showLoading: false, showServiceSubmissionErrorMessage: true, serviceSubmissionErrorMessage: error, convertingImages: false, showFormSection : true }, () => {
                        if (this.serviceErrorRef) {
                            this.serviceErrorRef.current.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                            });
                        }
                    });
                }
            });
        }

        let convertingInterval = setInterval(async () => {

            if (requestData.photos.length != convertedImages.length && !this.state.showServiceSubmissionErrorMessage) {
                return;
            }

            clearInterval(convertingInterval);
            
            if (!this.state.showServiceSubmissionErrorMessage) {
                if (requestData.photos && requestData.photos.length > 0) {
                    requestData.photos = convertedImages;
                }
                
                // include hidden sections with service form in request , which filter out on form load.
                let allSections = [...requestData.formData.formPages[0].sections,...this.state.hiddenSections];
        
                allSections = this.getSortedSection({sections : [...allSections]});
            
                requestData.formData.formPages[0].sections = [...allSections];
                requestData.sellerNotes = this.state.sellerNotes;

                let token = this.props.match.params.token;
                let sellerSEOName = this.props.match.params.sellerSEOName;

                let res = undefined;
                try{ 
                    if(token && sellerSEOName)
                    {
                        res = await submitSellerCustomerRequestFormForBuyer(sellerSEOName, token, requestData)
                    }else if(token)
                    {
                        res = await submitSellerCustomerRequestFormForSeller(token, requestData)
                    }
                }catch(e){

                }

                if(res)
                {
                    if(res.resStatus && res.resStatus == 200)
                    {
                        // succes redirect to invoice page.
                        if(this.state.requestData.scRequestID)
                        {
                            this.props.history.push(`/customer/request/${this.state.requestData.scRequestID}/invoice`)
                        }else
                        {
                            this.props.history.push('/customer/requests') 
                        }
                    }else
                    {
                        // error
                        this.setState({ showLoading: false, showServiceSubmissionErrorMessage: true, serviceSubmissionErrorMessage: res.message, convertingImages: false, showFormSection : true }, () => {
                            if (this.serviceErrorRef) {
                                this.serviceErrorRef.current.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                });
                            }
                        });
                    }
                }
            }
        }, 1000);
    }


    onPreviousClick = (topButtonClick) => {
        this.setState({showFormSection : false
            // , animationState : transitionStyles.previousOut
            })

        setTimeout(() => {
            let { requestData, service, files } = this.state;
            logSubmitFormValidated(service, this.props.currentUser, 0);
            let { formData } = requestData;
            let page = formData.formPages[0];
        try {
            if (this.formRef && this.formRef.current) {
                const { inputs } = this.formRef.current;
                const sections = page.sections;
                for (let i = 0; i < inputs.length; i++) {
                    const input = inputs[i];
                    const inputValue = input.getValue();
                    const sectionID = input.props.sectionID;
                    let section = _.find(page.sections, (sec) => {
                        return (sec.sectionID === sectionID);
                    }, 0);

                    const fieldID = input.props.fieldID;
                    if (fieldID) {

                        let field = _.find(section.fields, (fld) => {
                            return (fld.fieldID === fieldID);
                        }, 0);

                        field.value = inputValue ? inputValue : '';
                    }
                    else {
                        
                        _.forEach(section.fields, (field) => {
                            
                            if (!_.isEmpty(inputValue)) {
                                
                                if (_.includes(inputValue, field.fieldID.toString())) {
                                    
                                    field.value = 'checked';
                                }else if(section.type == "radio" && field.value == 'checked')
                                {
                                    field.value = '';
                                }
                            }
                            else if (field.fieldID == inputValue) {
                                
                                field.value = 'checked';
                            }else if (field.value == "checked" && section.type === 'multi')
                            {
                                
                                field.value = 'checked';
                            }
                            else {
                                
                                if (section.type === 'multi') {
                                    field.value = '';
                                }
                                else {
                                    field.value = false;
                                }
                            }
                        })
                    }
                }
            }


            this.setState({sectionCounter : this.state.sectionCounter - 1, showFormSection : true
                // , animationState : transitionStyles.previousIn
                })
            window.scrollTo({
                    top: 80,
                    behavior: 'smooth'
                  });
            if(topButtonClick)
            {              
                this.onScroll();
            }
        }      
        catch (error) {
            this.setState({ showLoading: false, showServiceSubmissionErrorMessage: true, serviceSubmissionErrorMessage: error, convertingImages: false , showFormSection : true }, () => {
                if (this.serviceErrorRef) {
                    this.serviceErrorRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            });
        }   
        }, annimationDuration);       
    }
    
    isLastSection = () => {
        return (
            (this.state.service.requiresImage && this.state.sectionCounter === (this.formPages[0].sections.length )) 
            || (!this.state.service.requiresImage && this.state.sectionCounter === (this.formPages[0].sections.length - 1))
        )
    }

    haveMultipleSectionToRender = () => {
        return this.formPages[0].sections.length > 1 ? true : false;
    }

    handleSellerNotesModalClose = () => {
        this.setState({sellerNotesModalOpen : false} , () => {
            this.compressImagesAndSubmitForm();
        });
    }

    onSellerNotesSubmit = (value) => {
        this.setState({sellerNotes : value} , () => {
            this.handleSellerNotesModalClose();
        })
    }

    redirectToHomePage = () => {
        this.props.history.push(NavigationUrls.CUSTOMER_REQUESTS_LIST);  
    }

    render() {
        
        return (
            <React.Fragment>

                {
                    this.state.showError == true ? 
                    <div id="error-container" class="error-container">
                        {/* <span class="main-heading">Thank You.</span> */}
                        <span class="sub-heading">Request token is not valid.</span>
                    </div>
                :
                    this.state.loadPage &&
                        <Container fluid className="service-request-form-container">
                        <div className="main-page-panel main-body">
                            <div className="content-panel service-form">
                                {
                                this.state.windowWidth >= 768  ? 
                                <>
                                    {/* <RequestFormPageHeaderStepbyStep 
                                        heading={this.state.pageHeading || "Get Discounted Rates by Booking with Dealgrace’s Top Rated Tow Companies"} 
                                        highlightText={this.state.service.headingHighlightedText ? this.state.service.headingHighlightedText : this.state.pageHeading} /> */}
                                    
                                    <ServiceNameHeader heading={this.state.service.name} />
                                    {/* <div className={"previous-top-arrows-containers"}>
                                        {
                                        //this.isPromoSection() 
                                        this.isLastSection() && this.haveMultipleSectionToRender()
                                        ? 
                                        <img className={"previous-top-arrows"} src={previous_back_arrow} onClick={() => this.onPreviousClick(false)}/> // false b/c we dont wnat to hit onScroll() here
                                        : null }
                                    </div> */}
                                    <div className={`progress-bar-container hide-Progress-Text ${/*this.isPromoSection()*/  this.isLastSection() ? "promo-section-progress-bar" : ""} ${this.state.totalSections == 1 ? "single-section" : ""}`}>
                                        <div className={"horizontal-line"}></div>                                  
                                        <Progress value={this.state.sectionCounter+1} total={this.state.totalSections} progress='ratio' size={"medium"}/>
                                    </div>
                                    <div className={"customer-detail-container"}>
                                        <div className={"heading"}>
                                            Customer
                                        </div>
                                  
                                        <div className={"customer-details"}>
                                            
                                            { this.state.customerDetails 
                                                && this.state.customerDetails?.customerName 
                                                && this.state.customerDetails?.customerName?.length 
                                                && this.state.customerDetails?.customerName?.trim().length ? 
                                            <div className={"customer-name"}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21.277" height="21.276" viewBox="0 0 21.277 21.276">
                                                    <defs>
                                                    <clipPath id="clip-path">
                                                        <rect id="Rectangle_9020" data-name="Rectangle 9020" width="8.422" height="11.426" fill="#4a7bf7"/>
                                                    </clipPath>
                                                    </defs>
                                                    <g id="Ellipse_10785" data-name="Ellipse 10785" fill="#fff" stroke="#4a7bf7" stroke-width="1">
                                                    <ellipse cx="10.638" cy="10.638" rx="10.638" ry="10.638" stroke="none"/>
                                                    <ellipse cx="10.638" cy="10.638" rx="10.138" ry="10.138" fill="none"/>
                                                    </g>
                                                    <g id="Group_16303" data-name="Group 16303" transform="translate(6.427 4.925)">
                                                    <g id="Group_16302" data-name="Group 16302" clip-path="url(#clip-path)">
                                                        <path id="Path_42119" data-name="Path 42119" d="M4.213,121.986H.672a.608.608,0,0,1-.671-.67q0-1.148,0-2.3a3,3,0,0,1,1.963-2.861,2.7,2.7,0,0,1,.966-.186c.854,0,1.709-.007,2.563,0a3.01,3.01,0,0,1,2.8,2.144,3.255,3.255,0,0,1,.125.9c0,.765-.012,1.53,0,2.295a.645.645,0,0,1-.678.682c-1.177-.012-2.353,0-3.53,0" transform="translate(0 -110.564)" fill="#4a7bf7"/>
                                                        <path id="Path_42120" data-name="Path 42120" d="M41.1,0a2.4,2.4,0,1,1-2.41,2.4A2.408,2.408,0,0,1,41.1,0" transform="translate(-36.884 0)" fill="#4a7bf7"/>
                                                    </g>
                                                    </g>
                                                </svg>
                                                <div className={"name"}>
                                                    {this.state.customerDetails?.customerName}
                                                </div>
                                            </div> : ""
                                            }

                                            <div className={"customer-phone"}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21.277" height="21.276" viewBox="0 0 21.277 21.276">
                                                    <defs>
                                                        <clipPath id="clip-path">
                                                        <rect id="Rectangle_9021" data-name="Rectangle 9021" width="10.552" height="10.554" fill="#4a7bf7"/>
                                                        </clipPath>
                                                    </defs>
                                                    <g id="Ellipse_10786" data-name="Ellipse 10786" fill="#fff" stroke="#4a7bf7" stroke-width="1">
                                                        <ellipse cx="10.638" cy="10.638" rx="10.638" ry="10.638" stroke="none"/>
                                                        <ellipse cx="10.638" cy="10.638" rx="10.138" ry="10.138" fill="none"/>
                                                    </g>
                                                    <g id="Group_16304" data-name="Group 16304" transform="translate(5.447 5.372)">
                                                        <g id="Group_16305" data-name="Group 16305" clip-path="url(#clip-path)">
                                                        <path id="Path_42121" data-name="Path 42121" d="M7.855,10.554c-.125-.016-.318-.037-.511-.066q-.23-.035-.458-.085c-.151-.033-.3-.073-.451-.115s-.279-.082-.416-.131c-.2-.074-.408-.149-.607-.235a8.678,8.678,0,0,1-1.024-.535,9.254,9.254,0,0,1-1.3-.942A9.636,9.636,0,0,1,1.424,6.571,8.724,8.724,0,0,1,.68,5.249C.564,4.99.463,4.724.37,4.456.295,4.242.234,4.023.179,3.8.134,3.619.1,3.432.069,3.245.046,3.108.03,2.97.013,2.832a2.124,2.124,0,0,1,.026-.616,2.352,2.352,0,0,1,.176-.579,2.388,2.388,0,0,1,.5-.726C.932.7,1.144.479,1.362.267a.892.892,0,0,1,.8-.254.89.89,0,0,1,.5.254c.428.427.858.853,1.283,1.283a.9.9,0,0,1,.252.812.879.879,0,0,1-.257.492l-.9.9a.074.074,0,0,0-.021.1A6.645,6.645,0,0,0,3.785,5.2,7.236,7.236,0,0,0,5.563,6.916a6.753,6.753,0,0,0,1.158.625c.034.015.052,0,.072-.023.236-.236.471-.473.709-.707A3.067,3.067,0,0,1,7.849,6.5a.862.862,0,0,1,.721-.127.9.9,0,0,1,.446.252q.631.631,1.262,1.262a.9.9,0,0,1,.274.671.872.872,0,0,1-.247.613c-.243.25-.488.5-.739.738a2.316,2.316,0,0,1-.842.506,2.783,2.783,0,0,1-.868.143" transform="translate(0 0)" fill="#4a7bf7"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <div className={"phone"}>
                                                    {format(this.state.customerDetails?.cellPhone)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                : ""}

                                {
                                    this.state.windowWidth < 768  ? 
                                    <>
                                    {/* <div className={"previous-top-arrows-containers"}>
                                            {
                                            //this.isPromoSection() 
                                            this.isLastSection() && this.haveMultipleSectionToRender()
                                            ? 
                                            <img className={"previous-top-arrows"} src={previous_back_arrow} onClick={() => this.onPreviousClick(true)}/>
                                            : null }
                                    </div> */}
                                    <div onClick={() => {this.redirectToHomePage()}} className={"home-icon-container"}>
                                        <svg className={"home-icon"} xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
                                            <defs>
                                                <clipPath id="clip-path">
                                                <rect id="Rectangle_9028" data-name="Rectangle 9028" width="21.679" height="20.981" transform="translate(0 0)" fill="#5d79e7"/>
                                                </clipPath>
                                            </defs>
                                            <g id="Group_16409" data-name="Group 16409" transform="translate(-15 -102)">
                                                <g id="Group_16407" data-name="Group 16407" transform="translate(-100 -49)">
                                                <g id="Group_16370" data-name="Group 16370" transform="translate(100 49)">
                                                    <rect id="Rectangle_9022" data-name="Rectangle 9022" width="41" height="41" rx="13" transform="translate(15 102)" fill="#ebf2fe"/>
                                                </g>
                                                </g>
                                                <g id="Group_16408" data-name="Group 16408" transform="translate(25 112)">
                                                <g id="Group_16404" data-name="Group 16404" transform="translate(0 0)" clip-path="url(#clip-path)">
                                                    <path id="Path_42133" data-name="Path 42133" d="M10.938,4.323c-.131.087-.248.161-.361.24C8.26,6.18,5.948,7.8,3.623,9.409a.853.853,0,0,0-.414.8c.013,3.42.007,6.841.009,10.261,0,.166.014.333.022.505H8.818V15.813h4v5.169H18.6a1.288,1.288,0,0,0,.026-.169c0-3.608.006-7.216-.009-10.824a.7.7,0,0,0-.272-.474c-.741-.546-1.5-1.065-2.257-1.593l-5.149-3.6M10.91,2.612c.689.489,1.363.965,2.036,1.444Q16.379,6.5,19.812,8.938A1.062,1.062,0,0,0,21.154,9a1.188,1.188,0,0,0,.452-1.368,1.934,1.934,0,0,0-.635-.769Q16.487,3.635,11.979.443a1.321,1.321,0,0,0-1.973,0Q5.3,3.8.6,7.167A1.221,1.221,0,0,0,.23,8.922c.4.558,1,.606,1.681.123Q3.933,7.606,5.948,6.16L10.91,2.612" transform="translate(0 0)" fill="#5d79e7"/>
                                                    <path id="Path_42134" data-name="Path 42134" d="M24.844,23.062l5.149,3.6c.755.528,1.516,1.047,2.257,1.593a.7.7,0,0,1,.272.473c.015,3.608.01,7.216.009,10.824a1.283,1.283,0,0,1-.026.169H26.725V34.552h-4v5.165H17.146c-.008-.172-.022-.339-.022-.505,0-3.42,0-6.841-.009-10.261a.853.853,0,0,1,.414-.8c2.325-1.6,4.637-3.229,6.954-4.846.113-.079.231-.153.361-.24" transform="translate(-13.907 -18.739)" fill="#5d79e7"/>
                                                    <path id="Path_42135" data-name="Path 42135" d="M10.91,2.612,5.948,6.16Q3.93,7.6,1.911,9.044C1.232,9.528.631,9.48.23,8.922A1.221,1.221,0,0,1,.6,7.167Q5.3,3.8,10.006.442a1.321,1.321,0,0,1,1.973,0q4.5,3.2,8.991,6.418a1.934,1.934,0,0,1,.635.769A1.188,1.188,0,0,1,21.154,9a1.062,1.062,0,0,1-1.341-.06Q16.376,6.5,12.946,4.056C12.274,3.577,11.6,3.1,10.91,2.612" transform="translate(0 0)" fill="#5d79e7"/>
                                                </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>                         

                                    <div className={`progress-bar-container hide-Progress-Text ${ /*this.isPromoSection()  this.isLastSection() ? "promo-section-progress-bar" : "" */ "" } ${this.state.totalSections == 1 ? "single-section" : ""}`}>
                                        <Progress value={this.state.sectionCounter+1} total={this.state.totalSections}progress='ratio' size={"medium"}/>
                                    </div>
                                    {/* <RequestFormPageHeaderStepbyStep heading={this.state.pageHeading || "Get Discounted Rates by Booking with Dealgrace’s Top Rated Tow Companies"} highlightText={this.state.service.headingHighlightedText ? this.state.service.headingHighlightedText : this.state.pageHeading} /> */}
                                    <div className={"customer-detail-container"}>
                                        <div className={"heading"}>
                                            Customer
                                        </div>
                                        <div className={"horizontal-line"}></div>
                                        <div className={"customer-details"}>
                                            
                                            { this.state.customerDetails 
                                                && this.state.customerDetails?.customerName 
                                                && this.state.customerDetails?.customerName?.length 
                                                && this.state.customerDetails?.customerName?.trim().length ? 
                                            <div className={"customer-name"}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21.277" height="21.276" viewBox="0 0 21.277 21.276">
                                                    <defs>
                                                    <clipPath id="clip-path">
                                                        <rect id="Rectangle_9020" data-name="Rectangle 9020" width="8.422" height="11.426" fill="#4a7bf7"/>
                                                    </clipPath>
                                                    </defs>
                                                    <g id="Ellipse_10785" data-name="Ellipse 10785" fill="#fff" stroke="#4a7bf7" stroke-width="1">
                                                    <ellipse cx="10.638" cy="10.638" rx="10.638" ry="10.638" stroke="none"/>
                                                    <ellipse cx="10.638" cy="10.638" rx="10.138" ry="10.138" fill="none"/>
                                                    </g>
                                                    <g id="Group_16303" data-name="Group 16303" transform="translate(6.427 4.925)">
                                                    <g id="Group_16302" data-name="Group 16302" clip-path="url(#clip-path)">
                                                        <path id="Path_42119" data-name="Path 42119" d="M4.213,121.986H.672a.608.608,0,0,1-.671-.67q0-1.148,0-2.3a3,3,0,0,1,1.963-2.861,2.7,2.7,0,0,1,.966-.186c.854,0,1.709-.007,2.563,0a3.01,3.01,0,0,1,2.8,2.144,3.255,3.255,0,0,1,.125.9c0,.765-.012,1.53,0,2.295a.645.645,0,0,1-.678.682c-1.177-.012-2.353,0-3.53,0" transform="translate(0 -110.564)" fill="#4a7bf7"/>
                                                        <path id="Path_42120" data-name="Path 42120" d="M41.1,0a2.4,2.4,0,1,1-2.41,2.4A2.408,2.408,0,0,1,41.1,0" transform="translate(-36.884 0)" fill="#4a7bf7"/>
                                                    </g>
                                                    </g>
                                                </svg>
                                                <div className={"name"}>
                                                    {this.state.customerDetails?.customerName}
                                                </div>
                                            </div> : ""
                                            }

                                            <div className={"customer-phone"}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21.277" height="21.276" viewBox="0 0 21.277 21.276">
                                                    <defs>
                                                        <clipPath id="clip-path">
                                                        <rect id="Rectangle_9021" data-name="Rectangle 9021" width="10.552" height="10.554" fill="#4a7bf7"/>
                                                        </clipPath>
                                                    </defs>
                                                    <g id="Ellipse_10786" data-name="Ellipse 10786" fill="#fff" stroke="#4a7bf7" stroke-width="1">
                                                        <ellipse cx="10.638" cy="10.638" rx="10.638" ry="10.638" stroke="none"/>
                                                        <ellipse cx="10.638" cy="10.638" rx="10.138" ry="10.138" fill="none"/>
                                                    </g>
                                                    <g id="Group_16304" data-name="Group 16304" transform="translate(5.447 5.372)">
                                                        <g id="Group_16305" data-name="Group 16305" clip-path="url(#clip-path)">
                                                        <path id="Path_42121" data-name="Path 42121" d="M7.855,10.554c-.125-.016-.318-.037-.511-.066q-.23-.035-.458-.085c-.151-.033-.3-.073-.451-.115s-.279-.082-.416-.131c-.2-.074-.408-.149-.607-.235a8.678,8.678,0,0,1-1.024-.535,9.254,9.254,0,0,1-1.3-.942A9.636,9.636,0,0,1,1.424,6.571,8.724,8.724,0,0,1,.68,5.249C.564,4.99.463,4.724.37,4.456.295,4.242.234,4.023.179,3.8.134,3.619.1,3.432.069,3.245.046,3.108.03,2.97.013,2.832a2.124,2.124,0,0,1,.026-.616,2.352,2.352,0,0,1,.176-.579,2.388,2.388,0,0,1,.5-.726C.932.7,1.144.479,1.362.267a.892.892,0,0,1,.8-.254.89.89,0,0,1,.5.254c.428.427.858.853,1.283,1.283a.9.9,0,0,1,.252.812.879.879,0,0,1-.257.492l-.9.9a.074.074,0,0,0-.021.1A6.645,6.645,0,0,0,3.785,5.2,7.236,7.236,0,0,0,5.563,6.916a6.753,6.753,0,0,0,1.158.625c.034.015.052,0,.072-.023.236-.236.471-.473.709-.707A3.067,3.067,0,0,1,7.849,6.5a.862.862,0,0,1,.721-.127.9.9,0,0,1,.446.252q.631.631,1.262,1.262a.9.9,0,0,1,.274.671.872.872,0,0,1-.247.613c-.243.25-.488.5-.739.738a2.316,2.316,0,0,1-.842.506,2.783,2.783,0,0,1-.868.143" transform="translate(0 0)" fill="#4a7bf7"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <div className={"phone"}>
                                                    {format(this.state.customerDetails?.cellPhone)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </>
                                    : ""
                                }

                                <Dimmer.Dimmable as="div" className="" style={{marginLeft:'0%' , 
                                //minHeight:'50vh'
                                }}>
                                    <Dimmer inverted active={this.state.showLoading} className="service-loading">
                                        <Loader size='massive' inverted >Submitting form...</Loader>
                                    </Dimmer>
                                    {this.state.service && !isEmpty(this.state.service) &&
                                        <React.Fragment>
                                        
                                        {this.formPages && !isEmpty(this.formPages) &&
                            <>

                                            <Transition key={"Transition-container"} in={this.state.showFormSection} timeout={0} appear>
                                                            {state => (
                                                                <>
                                                <div key={"form-container-key"} className={`form-container ${this.state.showServiceSubmissionErrorMessage  ? "form-has-error" : ""}`} style={{
                                                    ...defaultStyle,
                                                    ...transitionStyles[state]
                                                    //...this.state.animationState
                                                }}>   

                                                {
                                                    this.state.windowWidth < 768 ? <ServiceNameHeader key={"key_"+this.state.service.name} heading={this.state.service.name}> </ServiceNameHeader> : null
                                                }                                        
                                                    <Formsy key={"Formsy_key"} ref={this.formRef} onInvalidSubmit={this.onInvalidSubmit} onValidSubmit={this.onValidSubmit}>
                                                    {this.formPages.map(this.renderPage)}                                                                                                       
                                                        {this.state.showServiceSubmissionErrorMessage &&
                                                            <div className="section-container" ref={this.serviceErrorRef}>
                                                                <GeneralMessage type={"error"} message={this.state.serviceSubmissionErrorMessage} />
                                                            </div>
                                                        }
                                                        <div className={`button-section-container button-section-container-fixed ${this.isLastSection() ? "button-section-container-submitted" : ""}`}>   
                                                            {
                                                                (this.state.sectionCounter === 0 /*|| this.isLastSection()*/ /*this.isPromoSection()*/  ? null  :  
                                                                    <div className={`previous-button-container ${ /*this.isPromoSection()*/ this.isLastSection() ? "previous-button-container-submitted" : ""}`}>
                                                                        <button onClick={() => this.onPreviousClick(false)} type="button" className="button-previous">
                                                                                
                                                                                { this.state.windowWidth >= 768 ?  <span>PREVIOUS</span> : "" }   
                                                                        </button>                                                                                     
                                                                    </div>  
                                                                ) 
                                                            }
                                                            <div className={`next-button-container  ${this.state.sectionCounter === 0 ? "next-button-container-center " : ''} ${ this.isLastSection() /*this.isPromoSection()*/  ? "next-button-container-last-section" : ""}`}>
                                                                <button type="submit" className={`button-next ${ /*this.isPromoSection()*/ this.isLastSection() ? "button-next-submitted" : ""}`}>
                                                                    
                                                                { (this.state.windowWidth >= 768 ||  /*this.isPromoSection()*/ this.isLastSection())  ?
                                                                    <span> {/*this.isPromoSection()*/  this.isLastSection() ? "DONE" : "NEXT"}</span>
                                                                : "" }
                                                                    </button> 
                                                            </div>
                                                        </div>
                                                    </Formsy>
                                                </div>
                                                    <div key={"div-one-key"} className={`bottom-div-one ${this.state.showServiceSubmissionErrorMessage ? "has-error" : ""} `} 
                                                    //style={{ ...defaultStyle , ...this.state.animationState}}
                                                    >                                                          
                                                    </div> 
                                                    <div key={"div-two-key"} className={`bottom-div-two ${this.state.showServiceSubmissionErrorMessage ? "has-error" : ""} `} 
                                                    //style={{ ...defaultStyle , ...this.state.animationState}}
                                                    >                                                          
                                                    </div>
                                                </>
                                                )}
                                                </Transition>
                                </>}                                                                                                 
                                        </React.Fragment>
                                    }
                                </Dimmer.Dimmable>
                            </div> { /* Service Form */}
                        </div> { /*Main Body */}
                    </Container>
                }
                

                    {/* {
                        this.state.windowWidth >= 768  ? <div className={"seperator"}> </div> : ""
                    }     */}

                <SellerNotesModal
                    isOpen={this.state.sellerNotesModalOpen}
                    onClose={() => this.handleSellerNotesModalClose()}
                    onSubmit={(value) => this.onSellerNotesSubmit(value)}
                    notesValue={this.state.sellerNotes}
                    placeholder={"Additional details"}
                    header={"Additional Details"}
                    submitButtonText={"Continue"}
                ></SellerNotesModal>
                
            </React.Fragment >
        )
    }
}


export default  withRouter(CustomerRequestFormContainer)
